import React from "react";
import { Row, Col, Form, Input, Select } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import { allValidation, recoveryQuestions, requiredValidation } from "../../../common/constants/Helpers";

const FinalRegistration = ({ ...props }) => {
  const { finalRegisterForm, isRegisterLoading, handleFinalRegisterClick, handleOnCancelClick } = props;

  const validatePasswords = (rule, value, callback) => {
    const pass = finalRegisterForm.getFieldValue("PASSWORD");
    const confirmPass = finalRegisterForm.getFieldValue("REPASSWORD");
    if (!confirmPass) {
      callback("Confirm passwrod is required");
    } else if (pass !== confirmPass) {
      callback("The password you have entered does not match");
    }
    callback();
  };

  return (
    <Form layout="vertical" form={finalRegisterForm}>
      <Col xl={20} lg={24} md={24} sm={24} xs={24}>
        <BannerCard title="Account Login & Recovery Information">
          <br />
          <Row gutter={[12, 12]}>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Email Address" name="EMAIL" rules={allValidation}>
                <Input />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Re-type Email Address" name="REEMAIL" rules={allValidation}>
                <Input />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Password" name="PASSWORD" rules={allValidation}>
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Re-type Password" name="REPASSWORD" rules={[...allValidation, { validator: validatePasswords }]}>
                <Input.Password />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Recovery Question" name="QUESTION" rules={requiredValidation}>
                <Select placeholder="Select a question">
                  {React.Children.toArray(
                    recoveryQuestions.map((eachQuestion) => {
                      return <Select.Option value={eachQuestion.ID}>{eachQuestion.QUESTION}</Select.Option>;
                    })
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={24} sm={24} xs={24}>
              <Form.Item label="Recovery Answer" name="ANSWER" rules={allValidation}>
                <Input />
              </Form.Item>
            </Col>
            <Form.Item name="AGENCY_ID" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="REFERENCE_CODE" hidden>
              <Input />
            </Form.Item>
            <Col>
              <CleanButton icon="check" onClick={handleFinalRegisterClick} loading={isRegisterLoading}>
                Continue
              </CleanButton>
            </Col>
            <Col>
              <CleanButton icon="times" onClick={handleOnCancelClick}>
                Cancel
              </CleanButton>
            </Col>
          </Row>
        </BannerCard>
      </Col>
    </Form>
  );
};

export default FinalRegistration;
